import { render, staticRenderFns } from "./AuditPendenciesCardPostDiff.vue?vue&type=template&id=057daea8&scoped=true"
import script from "./AuditPendenciesCardPostDiff.vue?vue&type=script&lang=js"
export * from "./AuditPendenciesCardPostDiff.vue?vue&type=script&lang=js"
import style0 from "./AuditPendenciesCardPostDiff.vue?vue&type=style&index=0&id=057daea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057daea8",
  null
  
)

export default component.exports